module.exports = __webpack_public_path__ + "assets/img/donation_empty@3x.abac7271.png";